"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _help_3_skillreg = _interopRequireDefault(require("../images/help_3_skillreg.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-unescaped-entities */
var skillRegistration = {
  id: "skillRegistration",
  title: {
    en: "Skill's registration",
    de: "Fähigkeiten registrieren"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _help_3_skillreg.default,
      alt: "",
      style: {
        width: "390px",
        height: "348px",
        display: "block",
        margin: "16px auto"
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Skill's registration and use"), /*#__PURE__*/_react.default.createElement("p", null, "To use acquired skill, go to skill window register skill at the skill shortcut slot to use."), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, "At the skill window self skill point should be put in, so that learned skill click(little bit brighter color of skill) icon (L_Click).")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, "After you clicked, you can move it to the shortcut slot by picking your skill icon (picking: When it is clinging to the mouse point)")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, "When a skill is registered. Shortcut slot's order keyboard 1~8 can be created.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, "Select a target to use your skill on, press 1key to use 1st slot registered skill."))))
  }
};
var _default = skillRegistration;
exports.default = _default;